function labelOf(value: unknown): string {
  if (typeof value === "string") {
    return value;
  }
  if (value && typeof value === "object") {
    const row = value as { label?: unknown; name?: unknown };
    if (typeof row.label === "string") {
      return row.label;
    }
    if (typeof row.name === "string") {
      return row.name;
    }
  }
  return "";
}

export const isSareeLikeProduct = (form: unknown): boolean => {
  if (!form || typeof form !== "object") {
    return false;
  }
  const row = form as Record<string, unknown>;
  const hay = [labelOf(row.type), labelOf(row.category), labelOf(row.subCategory), labelOf(row.artform)]
    .join(" ")
    .toLowerCase();
  return /\bsarees?\b|\bsaris?\b/.test(hay);
};

export const productWeightLabel = (form: unknown): string =>
  isSareeLikeProduct(form) ? "Weight of Saree(in Grams)" : "Weight (grams)";
